export const OUTCOMES = {
  not_called: "Not called",
  no_answer: "No answer",
  follow_up: "Follow-up",
  interested: "Interested",
  closed: "Closed",
  blacklisted: "Don't Call",
};

export const toCallWorkspaceLead = (record, group) => {
  const outcome = record.outcome || "not_called";
  const status = {
    not_called: "Not called",
    no_answer: "No answer",
    follow_up: "Follow-up",
    interested: "Called",
    closed: "Called",
    blacklisted: "Don't Call",
  }[outcome] || outcome.replace(/_/g, " ");
  const customer = record.customer || {};
  const batch = record.batch || {};
  const assignee = record.assignee || {};
  const taskId = record.task_id || record.id;
  const callType = record.call_type || {};
  return {
    id: taskId,
    taskId,
    batchId: record.source_type === "batch" ? record.source_id : null,
    leadId: record.lead_id,
    batchName: batch.name || "Direct call",
    callTypeId: callType.id || record.call_type_id || null,
    callTypeName: callType.name || "—",
    sourceType: record.source_type || "",
    priority: record.priority || "normal",
    name: customer.name || "Unnamed lead",
    phone: customer.mobile || "—",
    assignee: assignee.name || "Unassigned",
    assigneeId: assignee.id || null,
    status,
    outcome,
    statusReason: record.outcome_reason || "",
    remarks: record.remarks || "",
    followUpAt: record.next_follow_up_at,
    attempts: record.attempts ||
      (Number(record.call_attempts || 0) + Number(record.whatsapp_attempts || 0)),
    lastUpdated:
      record.next_follow_up_at || record.last_called_at || record.updated_at,
    group: group || (outcome === "blacklisted"
      ? "blacklist"
      : outcome === "follow_up"
        ? "follow_up"
        : outcome === "interested" || outcome === "closed"
          ? "called"
          : "active"),
    customer,
  };
};

export const getStoredUser = () => {
  try {
    return JSON.parse(localStorage.getItem("user") || "{}");
  } catch (error) {
    return {};
  }
};

export const getToken = () => getStoredUser().token || "";

export const isAssignmentAdmin = (user) => {
  const role = Number(user && user.role);
  const roleName = String(
    (user && (user.role_name || user.user_role)) || "",
  ).toLowerCase();
  return (
    role === 1 ||
    role === 2 ||
    roleName === "admin" ||
    roleName.indexOf("super") !== -1
  );
};

export const isSuperAdmin = (user) => {
  const roleName = String((user && (user.role_name || user.user_role)) || "").toLowerCase();
  return Number(user && user.role) === 1 || roleName === "superadmin" || roleName === "super admin";
};

export const today = () => new Date().toISOString().slice(0, 10);

export const minimumFollowUpDateTime = () => {
  const date = new Date();
  date.setSeconds(0, 0);
  date.setMinutes(date.getMinutes() + 1);
  const offset = date.getTimezoneOffset() * 60000;
  return new Date(date.getTime() - offset).toISOString().slice(0, 16);
};

export const formatDate = (value, includeTime, dateAndMonthOnly) => {
  if (!value) return "—";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return value;
  return date.toLocaleString(
    undefined,
    includeTime
      ? {
          year: "numeric",
          month: "short",
          day: "numeric",
          hour: "2-digit",
          minute: "2-digit",
        }
      : dateAndMonthOnly
        ? { month: "short", day: "numeric" }
        : { year: "numeric", month: "short", day: "numeric" },
  );
};

export const nextAction = (lead) => {
  if (lead.outcome === "closed") return "Complete";
  if (lead.outcome === "follow_up" && lead.next_follow_up_at)
    return "Follow up";
  if (lead.outcome === "not_called") return "Call";
  return "Review";
};
